import React, { Component } from 'react';
import Navigation from './Navigation';
import 'materialize-css/dist/css/materialize.min.css';
import M from "materialize-css";
import * as CONS from '../CONS'
import jwt from 'jsonwebtoken';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import Select from 'react-select'
import '../style/CreateUser.css'

class CreateUser extends Component {

    constructor(props) {
        super(props);
        if (!localStorage.getItem('jwtToken')) {
            this.props.history.push("/login");
        } else {
            var token = localStorage.getItem("jwtToken");
            const tokenDec = jwt.decode(token);
            if (tokenDec.level < 15)
                this.props.history.push("/login");
        }
    }

    state = {
        status: '',

        rol: [],
        username: '',
        password: '',
        password2: '',
        document_type: [],
        document_num: '',
        name: '',
        lastname: '',
        position: [],
        email: '',
        phone: '',
        cellphone: '',
        gender: [],
        admin_staff: [],
        boss: [],
        company: [],
        active: true,
        isParent: false,

        optionsRol: [],
        optionsDocument: [],
        optionsPosition: [],
        optionsGender: [],
        optionsAdminStaff: [],
        optionsBoss: [],
        optionsCompany: [],

        btnSubmit: "Ingresar",
        isNew: false,
        id_user: [],
        optionsUser: []
    }

    //  Verifica que los campos tengan valores válidos
    validateFields() {
        const { isNew, password, password2, username, email } = this.state;

        if (!isNew) {
            if (password.length <= 0 || password2.length <= 0) {
                this.showToastStatus("El campo contraseña es obligatoria");
                // this.setState({ status: "El campo contraseña es obligatoria" });
                return false;
            }
        }

        if (password !== password2) {
            this.showToastStatus("Las contraseñas no son iguales");
            // this.setState({ status: "Las contraseñas no son iguales" });
            this.input_password.focus();
            return false;
        }

        if (username.length > 45) {
            this.showToastStatus("El nombre de usuario es de máximo 45 caracteres");
            // this.setState({ status: "El nombre de usuario es de máximo 45 caracteres" });
            return false;
        }

        if (!username.match(/^[a-z0-9_-]{3,15}$/)) {
            this.showToastStatus("El nombre de usuario tiene caracteres no válidos");
            // this.setState({ status: "El nombre de usuario tiene caracteres no válidos" });
            return false;
        }

        if (!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) && email.length > 0) {
            this.showToastStatus("La dirección de correo no es válida");
            // this.setState({ status: "La dirección de correo no es válida" });
            this.input_email.focus();
            return false;
        }
        return true;
    }

    async fetchRol() {
        const response = await fetch(localStorage.getItem("api") + '/rol/', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }),
        })
            .catch(err => {
                this.setState({ status: CONS.err_server });
                return;
            })
        const data = await response.json();

        if (data.length > 0) {
            const optionsRol = data.map((row, i) => ({ value: row.id_rol, label: row.name }));
            this.setState({ optionsRol: optionsRol, rol: optionsRol[0] });
        }
    }

    async fetchDocument() {
        const response = await fetch(localStorage.getItem("api") + '/document/', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }),
        })
            .catch(err => {
                this.setState({ status: CONS.err_server });
                return;
            })
        const data = await response.json();
        if (data.length > 0) {
            const optionsDocument = data.map((row, i) => ({ value: row.id_document, label: row.name }));
            this.setState({ optionsDocument: optionsDocument, document_type: optionsDocument[0] });
        }
    }

    async fetchPosition() {
        const response = await fetch(localStorage.getItem("api") + '/position/', {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }),
        })
            .catch(err => {
                this.setState({ status: CONS.err_server });
                return;
            })
        const data = await response.json();
        if (data.length > 0) {
            const optionsPosition = data.map((row, i) => ({ value: row.id_position, label: row.name }));
            this.setState({ optionsPosition: optionsPosition, position: optionsPosition[0] });
        }
    }

    async fetchGender() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/gender/', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
            })

            const data = await response.json();
            if (data.length > 0) {
                const optionsGender = data.map((row, i) => ({ value: row.id_gender, label: row.name }));
                this.setState({ optionsGender: optionsGender, gender: optionsGender[0] });
            }
        } catch (err) {
            this.setState({ status: CONS.err_server });
            return;
        }
    }

    async fetchAdminStaff() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/admin_staff/', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
            })

            const data = await response.json();
            if (data.length > 0) {
                const optionsAdminStaff = data.map((row, i) => ({ value: row.id_admin_staff, label: row.name }));
                this.setState({ optionsAdminStaff: optionsAdminStaff, admin_staff: optionsAdminStaff[0] });
            }
        } catch (err) {
            this.setState({ status: CONS.err_server });
            return;
        }
    }

    async fetchBoss() {

        try {
            const response = await fetch(localStorage.getItem("api") + '/user/boss', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
            })

            const data = await response.json();
            if (data.length > 0) {
                const optionsBoss = data.map((row, i) => ({ value: row.id_user, label: row.name + " " + row.lastname }));
                this.setState({ optionsBoss: optionsBoss, boss: optionsBoss[0] });
            }
        } catch (err) {
            this.setState({ status: CONS.err_server });
            return;
        }
    }

    async fetchCompany() {

        try {
            const response = await fetch(localStorage.getItem("api") + '/company/', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
            })

            const data = await response.json();
            if (data.length > 0) {
                const optionsCompany = data.map((row, i) => ({ value: row.id_company, label: row.name }));
                this.setState({ optionsCompany: optionsCompany, company: optionsCompany[0] });
            }
        } catch (err) {
            this.setState({ status: CONS.err_server });
            return;
        }
    }

    /*
        Obtiene todos los usuarios de la plataforma
    */
    async fetchUser() {

        try {
            const response = await fetch(localStorage.getItem("api") + '/user', {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
            })

            const data = await response.json();
            if (data.length > 0) {
                const optionsUser = data.map((row, i) => ({ value: row.id_user, label: `${row.name} ${row.lastname} - ${row.document_num}` }));
                this.setState({ optionsUser: optionsUser });
            }
        } catch (err) {
            this.setState({ status: CONS.err_server });
            return;
        }
    }

    /*
          Obtiene todos un usuario específico del server
    */
    async fetchUserById(id_user) {

        try {
            const response = await fetch(localStorage.getItem("api") + '/user/' + id_user, {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
            })

            const data = await response.json();
            data.id_user = this.state.optionsUser.find(o => o.value === data.id_user)
            data.rol = this.state.optionsRol.find(o => o.value === data.rol)
            data.document_type = this.state.optionsDocument.find(o => o.value === data.document_type)
            data.position = this.state.optionsPosition.find(o => o.value === data.position)
            data.gender = this.state.optionsGender.find(o => o.value === data.gender)
            data.admin_staff = this.state.optionsAdminStaff.find(o => o.value === data.admin_staff)
            data.boss = this.state.optionsBoss.find(o => o.value === data.boss)
            data.company = this.state.optionsCompany.find(o => o.value === data.company)
            data.phone = data.phone ? data.phone : '';
            data.cellphone = data.cellphone ? data.cellphone : '';
            data.email = data.email ? data.email : '';
            data.isNew = true;
            data.btnSubmit = "Actualizar"
            this.setState(data);
            M.updateTextFields();
        } catch (err) {
            this.setState({ status: CONS.err_server });
            return;
        }
    }


    /*
        Envía por post los valores del form al server
        para crear un nuevo usuario
    */
    async createUser() {
        var {
            rol, username, password, password2,
            document_type, document_num, name,
            lastname, position, email, phone,
            cellphone, gender, admin_staff,
            boss, company, active, isParent
        } = this.state;

        rol = rol.value;
        document_type = document_type.value;
        position = position.value;
        gender = gender.value;
        admin_staff = admin_staff.value;
        boss = boss.value;
        company = company.value;

        const response = await fetch(localStorage.getItem("api") + '/user/', {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }),
            body: JSON.stringify(
                {
                    rol, username, password, password2,
                    document_type, document_num, name,
                    lastname, position, email, phone,
                    cellphone, gender, admin_staff,
                    boss, company, active, isParent
                }
            )
        })
            .catch(err => {
                this.setState({ status: CONS.err_server });

                return;
            })
        const data = await response.json();
        // this.setState({ status: data.status });
        this.showToastStatus(data.status);
    }

    /*
        Activa los beneficios de obsequio para todos los usuarios
        que cumplan con los parametros
    */
    activarBeneficio(beneficio) {
        switch (beneficio) {
            // Día de la mujer
            // gender: 2
            case 1:
                this.putBeneficio(20, 'mujer');
                break;

            // Día del hombre
            // gender: 1
            case 2:
                this.putBeneficio(18, 'hombre');
                break;

            // Día de la madre
            // gender: 2, isParent: 1 
            case 3:
                this.putBeneficio(19, 'mama');
                break;

            // Día del padre
            // gender: 1, isParent: 1
            case 4:
                this.putBeneficio(21, 'papa');
                break;
            default:
                break;
        }
    }

    async putPointToUser(point) {
        var token = localStorage.getItem("jwtToken");
        if (!token) { return; }
        const { id_user, level } = jwt.decode(token);
        if (level < 15) return;

        const boss = id_user, employee = this.state.id_user.value;
        try {
            const response = await fetch(localStorage.getItem("api") + '/boss_employee_point/', {
                method: 'POST',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                }),
                body: JSON.stringify(
                    { boss, employee, point }
                )
            });
            const data = await response.json();
            this.setState({ status: data.status });
        } catch (err) {
            console.log(err);
            this.setState({ status: CONS.err_server });
            return;
        }
    }

    async putBeneficio(id_gift, gift_name) {
        var token = localStorage.getItem("jwtToken");
        if (!token) { return; }
        const { id_user, level } = jwt.decode(token);
        if (level < 15) return;

        const MySwal = withReactContent(Swal);

        const { value: password } = await MySwal.fire({
            title: "Beneficio masivo",
            html: "<p>Esta acción restara los puntos de TODOS los usuarios que cumplan los requisitos.<br>" +
                "Escriba su contraseña</p>",
            type: 'warning',
            input: 'password',
            customClass: {
                input: 'create-user-swal-input'
            },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Dar beneficios',
            inputValidator: (value) => {
                if (!value) {
                    return 'El campo esta vacío'
                }
            }
        })

        if (password) {
            try {
                const response = await fetch(localStorage.getItem("api") + '/user/gift/' + gift_name, {
                    method: 'PUT',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }),
                    body: JSON.stringify(
                        {
                            id_user: id_user,
                            password: password,
                            id_gift: id_gift
                        }
                    )
                })
                const data = await response.json();
                this.setState({ status: data.status });
                if (data.errors) {
                    MySwal.fire(
                        'Cancelado',
                        'Contraseña incorrecta',
                        'error'
                    )
                } else {
                    MySwal.fire(
                        'Éxito',
                        'Se actualizaron los usuarios',
                        'success'
                    )
                }
            } catch (err) {
                MySwal.fire(
                    'Cancelado',
                    'No se realizaron cambios',
                    'error'
                )
                this.setState({ status: CONS.err_server });
                return;
            }

        } else {
            MySwal.fire(
                'Cancelado',
                'No se realizaron cambios',
                'error'
            )
        }
    }

    /*
        Restablece los puntos iniciales de todos los usuarios.
        Verifica que el usuario tenga los requisitos para hacer esta operación.
    */
    async resetPoint() {
        var token = localStorage.getItem("jwtToken");
        if (!token) { return; }
        const { id_user, level } = jwt.decode(token);
        if (level < 15) return;

        const MySwal = withReactContent(Swal);

        const { value: password } = await MySwal.fire({
            title: "Restablecimiento de Puntos",
            html: "<p>Esta acción restablecera los puntos de TODOS los usuarios.<br>" +
                "Se recomienda usarla a inicios de cada año.<br>" +
                "Escriba su contraseña</p>",
            type: 'warning',
            input: 'password',
            customClass: {
                input: 'create-user-swal-input'
            },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Restablecer',
            inputValidator: (value) => {
                if (!value) {
                    return 'El campo esta vacío'
                }
            }
        })

        if (password) {
            try {
                const response = await fetch(localStorage.getItem("api") + '/user/reset_point', {
                    method: 'PUT',
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    }),
                    body: JSON.stringify(
                        {
                            id_user: id_user,
                            password: password
                        }
                    )
                })
                const data = await response.json();
                this.setState({ status: data.status });
                if (data.errors) {
                    MySwal.fire(
                        'Cancelado',
                        'Contraseña incorrecta',
                        'error'
                    )
                } else {
                    MySwal.fire(
                        'Éxito',
                        'Se actualizaron los usuarios',
                        'success'
                    )
                }
            } catch (err) {
                MySwal.fire(
                    'Cancelado',
                    'No se realizaron cambios',
                    'error'
                )
                this.setState({ status: CONS.err_server });
                return;
            }

        } else {
            MySwal.fire(
                'Cancelado',
                'No se realizaron cambios',
                'error'
            )
        }
    }


    /*
        Agrega la información del usuario al formulario para su edición
    */
    async updateUser() {
        var {
            id_user,
            rol, username, password, password2,
            document_type, document_num, name,
            lastname, position, email, phone,
            cellphone, gender, admin_staff,
            boss, company, active, isParent
        } = this.state;

        id_user = id_user.value;
        rol = rol.value;
        document_type = document_type.value;
        position = position.value;
        gender = gender.value;
        admin_staff = admin_staff.value;
        boss = boss.value;
        company = company.value;

        const response = await fetch(localStorage.getItem("api") + '/user/' + id_user, {
            method: 'PUT',
            headers: new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json'
            }),
            body: JSON.stringify(
                {
                    rol, username, password, password2,
                    document_type, document_num, name,
                    lastname, position, email, phone,
                    cellphone, gender, admin_staff,
                    boss, company, active, isParent
                }
            )
        })
            .catch(err => {
                this.setState({ status: CONS.err_server });
                console.log(err);
                console.log(CONS.err_server);
                return;
            })
        const data = await response.json();
        // this.setState({ status: data.status });
        this.showToastStatus(data.status);
    }

    async givePointsToUser() {
        const MySwal = withReactContent(Swal);
        if (Object.keys(this.state.id_user).length < 1) {
            MySwal.fire({
                title: 'Sin usuarios',
                text: 'Seleccione un usuario para darle puntos',
                type: 'warning',
                timer: 2000
            })
        } else {
            const { value: point } = await MySwal.fire({
                title: 'Puntos',
                input: 'number',
                showCloseButton: true,
                customClass: {
                    input: 'create-user-swal-input'
                },
                inputValidator: (value) => {
                    if (!value) {
                        return 'Escribe un número válido'
                    }
                    if (value < 0 || value > 2500) {
                        return 'Escribe un número entre 0 y 2500'
                    }
                },
                inputPlaceholder: 'Ingresa los puntos a otorgar'
            })
            if (typeof point !== 'undefined')
                this.putPointToUser(point);
        }

    }

    showToastStatus(message) {
        // const { status } = this.state;
        // console.log(status)
        // if (status.length > 0) {
        const toastHtml = `<span><b>${message}</b></span>`;
        M.toast({ html: toastHtml, displayLength: 5000, classes: 'rounded toast-style' });
        //     this.cleanStatus();
        // }
    }

    cleanFields() {
        const { optionsRol, optionsDocument, optionsPosition, optionsGender,
            optionsAdminStaff, optionsBoss, optionsCompany } = this.state;


        this.setState({
            status: '',

            rol: optionsRol[0],
            username: '',
            password: '',
            password2: '',
            document_type: optionsDocument[0],
            document_num: '',
            name: '',
            lastname: '',
            position: optionsPosition[0],
            email: '',
            phone: '',
            cellphone: '',
            gender: optionsGender[0],
            admin_staff: optionsAdminStaff[0],
            boss: optionsBoss[0],
            company: optionsCompany[0],
            active: true,
            isParent: false,

            btnSubmit: "Ingresar",
            isNew: false,
            id_user: [],
        });
        M.updateTextFields();
    }

    handleCheckBoxChanged = (e) => {
        this.setState({
            [e.target.name]: e.target.checked
        });
    }

    handleInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    /*
        Realiza el setState para el componente Select
    */
    handleChangeSelect(e, name) {
        this.setState({ [name]: e === null ? [] : e })
    }

    /*
        Realiza el setState para el componente select con los usuarios
    */
    handleChangeSelectUser(e) {
        if (e !== null) {
            this.fetchUserById(e.value)
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validateFields()) {
            if (this.state.isNew)
                this.updateUser();
            else
                this.createUser()
        }
    }

    componentDidMount() {
        this.fetchRol();
        this.fetchDocument();
        this.fetchPosition();
        this.fetchGender();
        this.fetchAdminStaff();
        this.fetchBoss();
        this.fetchCompany();
        this.fetchUser();

        var elems = document.querySelectorAll('select');
        var optionsSelect = {};
        M.FormSelect.init(elems, optionsSelect);

        elems = document.querySelectorAll('.count_char');
        M.CharacterCounter.init(elems);
    }

    render() {

        var {
            rol, optionsRol,
            document_type, optionsDocument,
            position, optionsPosition,
            gender, optionsGender,
            admin_staff, optionsAdminStaff,
            boss, optionsBoss,
            company, optionsCompany,
            id_user, optionsUser,
            username, document_num, name, lastname,
            email, phone, cellphone,
            isParent, active,
            btnSubmit, isNew,
            password, password2,
            status
        } = this.state;

        const btnCleanFields = isNew ? <input className="btn update" id="submit" type="submit" value="+" onClick={() => this.cleanFields()} /> : '';

        var asterisk = <span className="asterisk">*</span>;

        return (
            <React.Fragment>
                <div className="shape-border-left hide-on-med-and-down"></div>
                <Navigation></Navigation>
                <div id="CreateUser" className="container">

                    <label >{status}</label>
                    <div className="row">
                        <form onSubmit={this.handleSubmit}>
                            <div className="row">
                                <div className="col s12 l6 left-align">
                                    <label> Rol en el sistema</label>
                                    <Select name="rol" classNamePrefix="select-user" options={optionsRol} placeholder="Rol en el sistema"
                                        value={rol} onChange={(e) => this.handleChangeSelect(e, "rol")} ref={(input) => { this.select_rol = input }}></Select>
                                </div>
                                <div className="input-field col s12 l6">
                                    <input id="username" name="username" type="text" className="validate count_char" required
                                        onChange={this.handleInputChange} data-length="45" maxLength="45" minLength="3" value={username} />
                                    <label htmlFor="username">Nombre de usuario {asterisk}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field col s12 l6">
                                    <input id="password" name="password" type="password" className="validate count_char" required={!isNew} onChange={this.handleInputChange} data-length="60"
                                        maxLength="60" minLength="6" ref={(input) => { this.input_password = input }} value={password} />
                                    <label htmlFor="password">Contraseña {isNew ? "" : asterisk}</label>
                                </div>
                                <div className="input-field col s12 l6">
                                    <input id="password2" name="password2" type="password" className="validate count_char" required={!isNew} onChange={this.handleInputChange} data-length="60"
                                        maxLength="60" minLength="6" value={password2} />
                                    <label htmlFor="password2">Repetir Contraseña {isNew ? "" : asterisk}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s12 l6 left-align">
                                    <Select name="document_type" classNamePrefix="select-user" options={optionsDocument} placeholder="Documento de identidad"
                                        value={document_type} onChange={(e) => this.handleChangeSelect(e, "document_type")} ref={(input) => { this.select_document_type = input }}></Select>
                                </div>
                                <div className="input-field col s12 l6">
                                    <input id="document_num" name="document_num" type="text" className="validate count_char" required onChange={this.handleInputChange} value={document_num} />
                                    <label htmlFor="document_num">Número de documento {asterisk}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field col s12 l6">
                                    <input id="name" name="name" type="text" className="validate count_char" required onChange={this.handleInputChange} data-length="45" maxLength="45" value={name} />
                                    <label htmlFor="name">Nombre {asterisk}</label>
                                </div>
                                <div className="input-field col s12 l6">
                                    <input id="lastname" name="lastname" type="text" className="validate count_char" required onChange={this.handleInputChange} data-length="45" maxLength="45" value={lastname} />
                                    <label htmlFor="lastname">Apellido {asterisk}</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s12 l6 left-align">
                                    <Select name="position" classNamePrefix="select-user" options={optionsPosition} placeholder="Área"
                                        value={position} onChange={(e) => this.handleChangeSelect(e, "position")} ref={(input) => { this.select_position = input }}></Select>
                                </div>
                                <div className="input-field col s12 l6">
                                    <input id="email" name="email" type="email" className="validate count_char" onChange={this.handleInputChange} data-length="100" maxLength="100"
                                        ref={(input) => { this.input_email = input }} value={email} />
                                    <label htmlFor="email">Correo electrónico</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="input-field col s12 l6">
                                    <input id="phone" name="phone" type="text" className="validate count_char" onChange={this.handleInputChange} data-length="45" maxLength="45" value={phone} />
                                    <label htmlFor="phone">Teléfono</label>
                                </div>
                                <div className="input-field col s12 l6">
                                    <input id="cellphone" name="cellphone" type="text" className="validate count_char" onChange={this.handleInputChange} data-length="45" maxLength="45" value={cellphone} />
                                    <label htmlFor="cellphone">Celular</label>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s12 l6 left-align">
                                    <Select name="gender" classNamePrefix="select-user" options={optionsGender} placeholder="Género"
                                        value={gender} onChange={(e) => this.handleChangeSelect(e, "gender")} ref={(input) => { this.select_gender = input }}></Select>

                                </div>
                                <div className="col s12 l6 center-align">
                                    <p>
                                        <label>
                                            <input id="isParent" name="isParent" type="checkbox" onChange={this.handleCheckBoxChanged} checked={isParent} />
                                            <span>¿Tiene hijos?</span>
                                        </label>
                                    </p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s12 l6 left-align">
                                    <Select name="admin_staff" classNamePrefix="select-user" options={optionsAdminStaff} placeholder="Administrativo u operativo"
                                        value={admin_staff} onChange={(e) => this.handleChangeSelect(e, "admin_staff")} ref={(input) => { this.select_admin_staff = input }}></Select>
                                </div>
                                <div className="col s12 l6 left-align">
                                    <Select name="boss" classNamePrefix="select-user" options={optionsBoss} placeholder="Jefe inmediato"
                                        value={boss} onChange={(e) => this.handleChangeSelect(e, "boss")} ref={(input) => { this.select_boss = input }}></Select>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col s12 l6 left-align">
                                    <Select name="company" classNamePrefix="select-user" options={optionsCompany} placeholder="Empresa/Compañía"
                                        value={company} onChange={(e) => this.handleChangeSelect(e, "company")} ref={(input) => { this.select_company = input }}></Select>
                                </div>
                                <p>
                                    <label>
                                        <input id="active" name="active" type="checkbox" onChange={this.handleCheckBoxChanged} checked={active} />
                                        <span>Activo en la compañia</span>
                                    </label>
                                </p>
                            </div>
                            <div className="input-field col s12 l6 offset-l3">
                                <input className="btn" id="submit" type="submit" value={btnSubmit} />
                                &nbsp;{btnCleanFields}
                            </div>
                        </form>
                    </div>
                    <hr></hr>
                    <h5>Actualizar usuarios</h5>
                    <div className="row">
                        <div className="col s12 m8">
                            <Select name="id_user" classNamePrefix="select-user" options={optionsUser} placeholder="Usuarios"
                                value={id_user} onChange={(e) => this.handleChangeSelectUser(e)} ref={(input) => { this.select_id_user = input }}></Select>
                        </div>
                        <div className="col s12 m4">
                            <button className="btn update" onClick={() => this.givePointsToUser()}>
                                Dar puntos
                            </button>
                        </div>
                    </div>
                    <hr></hr>
                    <h5>Días especiales</h5>
                    <div className="row special-day">
                        <div className="col s12 m3" >
                            <img className="" src={require('../img/beneficios/ico_mujer.png')} alt="ico_mujer.png"></img>
                            <button className="btn " onClick={() => this.activarBeneficio(1)}>
                                Día de la mujer
                            </button>
                        </div>
                        <div className="col s12 m3" >
                            <img className="" src={require('../img/beneficios/ico_hombre.png')} alt="ico_mujer.png"></img>
                            <button className="btn " onClick={() => this.activarBeneficio(2)}>
                                Día del hombre
                            </button>
                        </div>
                        <div className="col s12 m3" >
                            <img className="" src={require('../img/beneficios/ico_mama.png')} alt="ico_mujer.png"></img>
                            <button className="btn " onClick={() => this.activarBeneficio(3)}>
                                Día de la madre
                            </button>
                        </div>
                        <div className="col s12 m3" >
                            <img className="" src={require('../img/beneficios/ico_papa.png')} alt="ico_mujer.png"></img>
                            <button className="btn " onClick={() => this.activarBeneficio(4)}>
                                Día del padre
                            </button>
                        </div>
                    </div>
                    <hr></hr>
                    <h5>Otras acciones</h5>
                    <div className="row special-day">
                        <div className="col s12 m3" >
                            <img className="" src={require('../img/beneficios/ico_mama_papa.png')} alt="ico_mama_papa.png"></img>
                            <button className="btn " onClick={() => this.resetPoint()}>Restablecer puntos</button>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default CreateUser
